/**
 * @deprecated This file is DEPRECATED and will be removed in a future version.
 * Please use Redux Toolkit actions from 'src/store/slices/authSlice.ts' instead.
 *
 * Migration guide:
 * - Import actions from: import { loginUser } from '../../../store/slices/authSlice';
 * - Use useAppDispatch() hook instead of connect()
 */

import {
    actionCreator,
    loginActionTypes,
    // eslint-disable-next-line no-unused-vars
    jsonApiHeader
} from './../constants/apiConstants';
import history from '../../../history';
import { API_URL } from '../../../actions/utilAction';
import axios from 'axios';
import toastr from 'toastr';
import * as constant from '../../../actions/constant';

// eslint-disable-next-line no-unused-vars
let access_token = localStorage.access_token;

export function loginAction(authObj) {

    return (dispatch) => {
        axios.post(API_URL + constant.USER_LOGIN, authObj, {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(function(response) {
            if (response.data.code === 200) {
                dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, access_token: response.data.data.token, authData: response.data.data }));
                localStorage.setItem('access_token', response.data.data.token);
                history.push(constant.DASHBOARD);
                toastr.success(response.data.message)
            } else {
                toastr.error(response.data.message)
            }
        }).catch(function(error) {
            toastr.error('Login failed. Please try again.');
        })
    };
}

export function forgotPassword(authObj) {

    return (dispatch) => {
        axios.post(API_URL + constant.FORGOT_PASSWORD, authObj, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(function(response) {
                if (response.data.code === 200) {
                    history.push(constant.LOGIN);
                    toastr.success(response.data.message)
                } else {
                    toastr.error(response.data.message)
                }
            });
    };
}

export function resetPassword(obj) {

    return (dispatch) => {
        axios.post(API_URL + constant.RESET_PASSWORD, obj, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(function(response) {
                if (response.data.code === 200) {
                    history.push(constant.LOGIN);
                    toastr.success(response.data.message)
                } else {
                    toastr.error(response.data.message)
                }
            });
    };
}